import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithPhoneNumber,
  RecaptchaVerifier,
  GoogleAuthProvider,
  signInWithPopup,
  OAuthProvider
} from "firebase/auth";

// ✅ Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyAfvu0AgXtgfZaDojIvXmHCHAbtS_kfOlQ",
  authDomain: "nicra-63e41.firebaseapp.com",
  projectId: "nicra-63e41",
  storageBucket: "nicra-63e41.firebasestorage.app",
  messagingSenderId: "707739544615",
  appId: "1:707739544615:web:a173c9ef0f034772f03202",
  measurementId: "G-N6DDF8Q8K3"
};


// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider(); // ✅ Google Auth Provider
const appleProvider = new OAuthProvider("apple.com"); // ✅ Apple Auth Provider


// ✅ Setup reCAPTCHA (Invisible)
const setUpRecaptcha = () => {
  const recaptchaContainer = document.getElementById("recaptcha-container");

  if (!recaptchaContainer) {
    console.error("❌ reCAPTCHA container not found.");
    return;
  }

  // ✅ Check if reCAPTCHA already exists
  if (!window.recaptchaVerifier) {
    window.recaptchaVerifier = new RecaptchaVerifier(auth, recaptchaContainer, {
      size: "invisible",
      callback: (response) => {
        console.log("✅ reCAPTCHA Verified:", response);
      },
      "expired-callback": () => {
        console.log("⚠️ reCAPTCHA expired, resetting...");
        window.recaptchaVerifier.reset();
      },
    });

    // ✅ Ensure reCAPTCHA is rendered
    window.recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId;
    });
  }
};


// ✅ Function to handle Google Login
const signInWithGoogle = async () => {
  try {
      const result = await signInWithPopup(auth, googleProvider);
      return result.user; // Returns user details after successful login
  } catch (error) {
      console.error("Google Login Error:", error.message);
      throw error;
  }
};

// ✅ Function to handle Apple Login
const signInWithApple = async () => {
  try {
    const result = await signInWithPopup(auth, appleProvider);
    return result.user; // Returns user details after successful login
  } catch (error) {
    console.error("Apple Login Error:", error.message);
    throw error;
  }
};

export { auth, signInWithPhoneNumber, setUpRecaptcha, signInWithGoogle, signInWithApple  };
